import { observer } from 'mobx-react';
import * as React from 'react';

import { injectTSDI } from '../../core/tsdi';
import { I18nStore } from '../../core/i18n-store';

// @ts-ignore
// eslint-disable-next-line
import whatsappIcon from '../../../assets/images/whatsapp.svg';

import './share-on-whatsapp.scss';

interface ShareOnWhatsappProps {
    url: string;
    studioName: string;
}

export const ShareOnWhatsApp = observer((props: ShareOnWhatsappProps) => {
    const { studioName, url } = props;
    const { translate, translateWithoutTrace } = injectTSDI(I18nStore);
    const message = encodeURIComponent(
        translateWithoutTrace('whatsapp.invitation.text', studioName)
    );
    const href = `whatsapp://send?text=${message}${url}`;

    return (
        <ul className="sharing-icons">
            <li>
                <a href={href}>
                    <figure>
                        {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */}
                        <img src={whatsappIcon} alt="whatsapp" />
                        <figcaption>
                            {translate('onlinepages.whatsapp.recommend')}
                        </figcaption>
                    </figure>
                </a>
            </li>
        </ul>
    );
});
